/**
 * @module ol/style/IconAnchorUnits
 */

/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
export default {
  FRACTION: 'fraction',
  PIXELS: 'pixels'
};

//# sourceMappingURL=IconAnchorUnits.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/ol/style/IconAnchorUnits.js
// module id = ../../../../ol/style/IconAnchorUnits.js
// module chunks = 3